/**
 * Inhaltsverzeichnis aus Headlines in .yn-article.
 * Vorhandene IDs werden als Sprungmarken genutzt, fehlende ergänzt.
 */
const slugify = (text) => {
	const slug = text
		.toLowerCase()
		.replace(/ä/g, 'ae')
		.replace(/ö/g, 'oe')
		.replace(/ü/g, 'ue')
		.replace(/ß/g, 'ss')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '')

	return slug || 'section'
}

export function articleToc() {
	const asides = document.querySelectorAll('[data-article-toc]')
	if (!asides.length) return

	asides.forEach((aside) => {
		const list = aside.querySelector('ol')
		const scope = aside.closest('.row') || aside.closest('article') || document
		const article = scope.querySelector('.yn-article')

		if (!list || !article) {
			aside.hidden = true
			return
		}

		list.replaceChildren()
		const usedIds = new Set()

		const headings = [...article.querySelectorAll(':is(h2, h3, h4)')].filter(
			(heading) => heading.textContent.trim()
		)
		const padLength = Math.max(2, String(headings.length).length)

		headings.forEach((heading, index) => {
			const label = heading.textContent.trim()
			const number = String(index + 1).padStart(padLength, '0')

			let id = heading.id?.trim()
			if (!id) {
				id = slugify(label)
				let unique = id
				let i = 2
				while (usedIds.has(unique) || document.getElementById(unique)) {
					unique = `${id}-${i++}`
				}
				id = unique
				heading.id = id
			}

			usedIds.add(id)
			heading.dataset.tocNumber = number

			const li = document.createElement('li')
			li.dataset.level = heading.tagName.toLowerCase()
			li.dataset.tocNumber = number

			const link = document.createElement('a')
			link.href = `#${id}`
			link.textContent = label

			li.append(link)
			list.append(li)
		})

		aside.hidden = list.children.length === 0
	})
}
